import NoAppointmentContactDetailsModal from './NoAppointmentContactDetailsModal';

export default NoAppointmentContactDetailsModal;
